import React, { useContext } from 'react';

import { FormGroup } from '@material-ui/core';

import { CommaSeparatedEmailsField } from '@/core/users/UserInvite/CommaSeparatedEmailsField';
import { UserInviteContext } from '@/core/users/UserInvite/UserInviteContext';
import { LicenseTypeSelect } from '@/core/users/UserPermissions/UserDetails/LicenseTypeSelect';

export function UserInviteHeaderInputFields () {
  const { errors, validateEmails, inviteParams, setInviteParams, submitCount } = useContext(UserInviteContext);

  return (
    <FormGroup className="flex flex-row col-span-full">
      <LicenseTypeSelect
        licenseType={inviteParams.core?.licenseType}
        uvkAdmin={!!inviteParams.uvk}
        onChange={licenseType => {
          inviteParams.core!.licenseType = licenseType;
          setInviteParams(inviteParams);
          validateEmails();
        }}
        errorMessage={errors.core}
      />
      <CommaSeparatedEmailsField
        emails={inviteParams.commaSeparatedEmails}
        errorMessage={submitCount > 0 ? errors.emails : undefined}
        onChange={e => {
          inviteParams.commaSeparatedEmails = e.target.value;
          setInviteParams(inviteParams);
        }}
        onBlur={() => validateEmails()}
      />
    </FormGroup>
  );
}
